const trustItems = [
  { icon: 'ri-sun-fill', text: 'UV Sun-Cure Technology', color: 'text-[#FF6B35]' },
  { icon: 'ri-check-double-line', text: 'Epoxy & Poly Boards', color: 'text-[#0B5C4D]' },
  { icon: 'ri-suitcase-2-line', text: 'Travel-Friendly Kits', color: 'text-[#0B5C4D]' },
  { icon: 'ri-global-line', text: '60+ Countries Worldwide', color: 'text-[#0B5C4D]' },
  { icon: 'ri-time-line', text: 'Cures in 1–3 Minutes', color: 'text-[#FF6B35]' },
];

export default function SharedTrustBar() {
  return (
    <section className="bg-[#F5EFE6] border-y border-stone-200">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {trustItems.map((item, idx) => (
            <div key={item.text} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-sm ${item.color}`} />
              </div>
              <span className="text-stone-700 text-xs font-semibold uppercase tracking-wide whitespace-nowrap">{item.text}</span>
              {idx < trustItems.length - 1 && (
                <span className="hidden md:inline text-stone-300 ml-8">|</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
